"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MenuLoadingSkeleton = void 0;
var react_1 = __importDefault(require("react"));
var loading_skeleton_1 = require("@kaizen/loading-skeleton");
var MenuFooter_1 = require("../MenuFooter");
var MenuLoadingSkeleton_module_scss_1 = __importDefault(require("./MenuLoadingSkeleton.module.scss"));
var MenuLoadingSkeleton = function (_a) {
    var _b = _a.isAnimated, isAnimated = _b === void 0 ? false : _b;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { className: MenuLoadingSkeleton_module_scss_1["default"].loadingContainer },
            react_1["default"].createElement(loading_skeleton_1.LoadingInput, { classNameOverride: MenuLoadingSkeleton_module_scss_1["default"].loadingInput, isAnimated: isAnimated }),
            react_1["default"].createElement(loading_skeleton_1.LoadingParagraph, { isAnimated: isAnimated }),
            react_1["default"].createElement(loading_skeleton_1.LoadingParagraph, { isAnimated: isAnimated }),
            react_1["default"].createElement(loading_skeleton_1.LoadingParagraph, { isAnimated: isAnimated }),
            react_1["default"].createElement(loading_skeleton_1.LoadingParagraph, { isAnimated: isAnimated }),
            react_1["default"].createElement(loading_skeleton_1.LoadingParagraph, { isAnimated: isAnimated })),
        react_1["default"].createElement(MenuFooter_1.MenuFooter, null,
            react_1["default"].createElement(loading_skeleton_1.LoadingInput, { width: 40, height: 36, isAnimated: isAnimated }),
            react_1["default"].createElement(loading_skeleton_1.LoadingInput, { width: 30, height: 36, isAnimated: isAnimated }))));
};
exports.MenuLoadingSkeleton = MenuLoadingSkeleton;
exports.MenuLoadingSkeleton.displayName = "MenuLoadingSkeleton";
//# sourceMappingURL=MenuLoadingSkeleton.js.map